//returns true if the specified days passed from last date saved 
export const showed_later_days_diff = (date_time: number, days: number = 15) => {
  return date_time ? (new Date().getTime() - Number(date_time) > days * 24 * 60 * 60 * 1000) : true
}